// extracted by mini-css-extract-plugin
export default {"loading-container":"loading-container__qm2_s","spin":"spin__kqrLd"};